import React from 'react';
import { withRouter } from 'react-router-dom';
import axios from 'axios';
import CongestionChart from './CongestionChart';
import '../style/pages/NetworkCongestion.scss';

const HOST_PORT = (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1')
  ? 'http://localhost:3003' : 'https://api.blockhivetechnologies.com';

// Refresh once per hour — congestion is a slow-moving signal, no need for live polling
const POLL_MS = 60 * 60 * 1000;

const BTN = {
  background: '#383838', color: '#aaa', border: '1px solid #444',
  borderRadius: '3px', padding: '2px 8px', fontSize: '9px',
  cursor: 'pointer', letterSpacing: '0.5px', marginRight: '6px',
  fontFamily: 'inherit', lineHeight: 'normal'
};

function levelColor(level) {
  switch (level) {
    case 'HIGH': return '#ff4d4d';
    case 'MED':  return '#f7c948';
    case 'LOW':  return '#26c49a';
    default:     return '#888';
  }
}

class NetworkCongestion extends React.Component {
  state = { loading: true, error: null, data: null, history: null };
  _mounted = false;
  _timer = null;

  componentDidMount() {
    this._mounted = true;
    this.fetchData();
    this._timer = setInterval(() => this.fetchData(), POLL_MS);
  }
  componentWillUnmount() {
    this._mounted = false;
    if (this._timer) clearInterval(this._timer);
  }

  fetchData = async () => {
    try {
      const [snap, hist] = await Promise.all([
        axios.get(`${HOST_PORT}/network/congestion`, { timeout: 30000 }),
        axios.get(`${HOST_PORT}/network/congestion/history`, { timeout: 30000 }),
      ]);
      if (!this._mounted) return;
      this.setState({ data: snap.data, history: hist.data, loading: false, error: null });
    } catch (e) {
      if (!this._mounted) return;
      this.setState({ loading: false, error: e.message });
    }
  }

  render() {
    const { loading, error, data, history } = this.state;
    return (
      <div className="page-network-congestion">
        <div className="nc-border">
          <div className="nc-border-content">
            <div style={{ display: 'flex', alignItems: 'center', padding: '4px 2px' }}>
              <button style={BTN} onClick={() => this.props.history.push('/dashboard')}>← DASHBOARD</button>
              <span style={{ color: '#444', fontSize: '9px', letterSpacing: '2px' }}>NETWORK CONGESTION</span>
            </div>

            <div className="nc-inner">
              <header className="nc-header">
                <div className="nc-title">NETWORK CONGESTION</div>
                <div className="nc-sub">
                  current network state vs 30-day baseline · refresh hourly · sourced from mempool.space + eth_feeHistory
                </div>
              </header>

              {/* Integrated chart panel: chain status tabs + 90D baseline chart */}
              {history && history.btc && (
                <section className="nc-chart">
                  <div className="nc-section-title">NETWORK CONGESTION · CURRENT vs 90D BASELINE</div>
                  <div className="nc-chart-canvas">
                    <CongestionChart
                      data={history.btc}
                      unit="sat/vB"
                      chainStates={data}
                    />
                  </div>
                </section>
              )}

              {loading && !data && <div className="nc-state">Loading…</div>}
              {error && <div className="nc-state nc-error">Failed: {error}</div>}

              <footer className="nc-footer">
                v1 · standalone test page · target placement: under BlockClock on /dashboard
              </footer>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(NetworkCongestion);
